import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Material UI
import { TimePicker as MuiTimePicker } from '@material-ui/pickers';
// Custom
import { dateFormatter, localeData } from 'utils/DateUtils';
import { CloseIconButton } from 'components/buttons/IconButtons';
import MuiInputAdornment from '@material-ui/core/InputAdornment';

// Label formatter
const handleFormatLabel = (date) => (date ? dateFormatter.toLocalizedTime(date) : '');

const TimePicker = ({
  variant,
  label,
  value,
  errorText,
  clearable,
  disabled,
  minutesStep,
  fullWidth,
  margin,
  onChange,
  isError,
  required,
  icon,
  placeholder,
}) => {
  // Error flag
  const error = !_isEmpty(errorText) || isError;

  // Component props
  let componentProps = {
    value,
    disabled,
    minutesStep,
    variant,
    autoOk: variant === 'inline',
    onChange,
    placeholder,
  };
  if (variant === 'dialog') {
    componentProps = {
      ...componentProps,
      cancelLabel: <LocalizedMessage id="button.cancel" />,
    };
  }

  // Internal TextField props
  const textFieldProps = {
    label,
    error,
    helperText: errorText,
    fullWidth,
    margin,
    required,
  };

  let clearableTopPosition = 9;
  if (margin === 'normal') {
    clearableTopPosition = 24;
  }

  return (
    <React.Fragment>
      <MuiTimePicker
        labelFunc={handleFormatLabel}
        ampm={localeData.usesAmPm()}
        {...componentProps}
        {...textFieldProps}
        InputProps={{
          startAdornment: icon ? <MuiInputAdornment position="start">{icon}</MuiInputAdornment> : null,
        }}
      />
      {clearable && value && (
        <div style={{ position: 'absolute', top: clearableTopPosition, right: 14 }}>
          <CloseIconButton onClick={() => onChange(null)} tooltipId="tooltip.empty" />
        </div>
      )}
    </React.Fragment>
  );
};

TimePicker.propTypes = {
  variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  value: PropTypes.instanceOf(Date),
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isError: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  minutesStep: PropTypes.number,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  icon: PropTypes.element,
  placeholder: PropTypes.string,
};

TimePicker.defaultProps = {
  variant: 'inline',
  label: null,
  value: null,
  errorText: null,
  isError: false,
  clearable: false,
  disabled: false,
  minutesStep: 1,
  fullWidth: true,
  margin: 'normal',
  required: false,
  icon: null,
  placeholder: null,
};

export default React.memo(TimePicker);



// WEBPACK FOOTER //
// ./components/core/TimePicker.js